import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { ShiftStoreSchema } from "sh-shift-store";

export default mutatorAction('SET_SHIFTS_CACHE_START_TIME_IN_STORE', function setShiftsCacheStartTimeInStore(shiftsCacheStartTime: Moment, shiftStoreEntity: ShiftStoreSchema) {
    shiftStoreEntity.shiftsCacheStartTime = shiftsCacheStartTime;
});
